<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-800 p-4">
    <div class="max-w-lg w-full bg-white dark:bg-gray-900 shadow-md rounded-lg p-8">
      <h2 class="text-2xl font-bold mb-6 text-gray-900 dark:text-white">
        Create New Project Feedback Page
      </h2>
      <form @submit.prevent="submitProject" class="space-y-6">
        <!-- Project Name -->
        <div>
          <label class="block text-gray-700 dark:text-gray-300 mb-2">Project Name</label>
          <input
            type="text"
            v-model="form.projectName"
            required
            class="w-full p-2 border border-gray-300 rounded dark:bg-gray-800 dark:text-white"
          />
        </div>
        <!-- Producer Selector: Searchable Dropdown -->
        <div>
          <label class="block text-gray-700 dark:text-gray-300 mb-2">Producers</label>
          <!-- Search input -->
          <input
            type="text"
            v-model="producerSearchTerm"
            placeholder="Search producers..."
            class="w-full p-2 border border-gray-300 rounded dark:bg-gray-800 dark:text-white mb-2"
          />
          <!-- Dropdown list of filtered producers -->
          <div class="border border-gray-300 rounded dark:bg-gray-800 max-h-40 overflow-y-auto">
            <div
              v-for="producer in filteredProducers"
              :key="producer.id"
              class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer"
              @click="selectProducer(producer.id)"
            >
              {{ producer.name }}
            </div>
          </div>
          <!-- Selected producers display -->
          <div class="mt-2">
            <span
              v-for="(prod, index) in form.producers"
              :key="prod"
              class="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded mr-1 mb-1"
            >
              {{ availableProducers.find(p => p.id === prod)?.name || prod }}
              <button type="button" class="ml-1 text-red-600" @click="removeProducer(index)">x</button>
            </span>
          </div>
        </div>
        <!-- Production Timeframe as Date Selector (Optional) -->
        <div>
          <label class="block text-gray-700 dark:text-gray-300 mb-2">Production Timeframe</label>
          <input
            type="date"
            v-model="form.productionTimeframe"
            class="w-full p-2 border border-gray-300 rounded dark:bg-gray-800 dark:text-white"
          />
        </div>
        <!-- Initial Brief (Optional) -->
        <div>
          <label class="block text-gray-700 dark:text-gray-300 mb-2">Initial Brief</label>
          <textarea
            v-model="form.initialBrief"
            class="w-full p-2 border border-gray-300 rounded dark:bg-gray-800 dark:text-white"
            placeholder="Enter initial brief (optional)"
          ></textarea>
        </div>
        <!-- Error Display -->
        <div v-if="error" class="text-red-600">
          {{ error }}
        </div>
        <!-- Submit Button -->
        <div>
          <button
            type="submit"
            class="w-full py-2 px-4 bg-navyblue hover:bg-lightblue text-white font-bold rounded"
          >
            {{ loading ? "Creating..." : "Create Project Page" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ProductionFormLogic from "./ProductionFormLogic.js";

export default {
  name: "ProductionForm",
  ...ProductionFormLogic
};
</script>

<style scoped>
/* Add any additional styling if necessary */
</style>
